//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { KintellCard } from '@/models'
import { get } from 'vuex-pathify'
import { ChecksFocus, UsesAuthenticatedUser, UsesKintellGroup } from '@/mixins'

export default {
  mixins: [
    ChecksFocus,
    UsesKintellGroup,
    UsesAuthenticatedUser
  ],
  data () {
    return {
      kintellCard: {},
      filter: {
        query: '',
        group: ''
      }
    }
  },
  computed: {
    ...get({
      card: 'kintellCards/activeKintellCard',
    }),
    kintellGroup () {
      const { kintellGroup } = new KintellCard(this.card)
      return kintellGroup
    },
    placeholder () {
      let placeholder = {
        label: 'Find an advisor',
        title: 'Search Kintell advisors'
      }
      if (this.kintellGroup && this.kintellGroup?.name) {
        const maxChars = 15
        const groupPlaceholderText = `Search ${this.kintellGroup?.name}`
        const truncatedPlaceholder = (groupPlaceholderText.length > maxChars) ? (groupPlaceholderText.substr(0, maxChars) + '...') : groupPlaceholderText

        placeholder = {
          label: truncatedPlaceholder,
          title: `Search advisors in ${this.kintellGroup?.name}`
        }
      }
      return placeholder
    }
  },
  methods: {
    search () {
      const query = this.filter.query
      if (!query) {
        return
      }
      if (this.kintellGroup?.id) {
        const slug = this.kintellGroup.slug
        this.$router.push(`/g/${slug}?query=${query}`)
      } else {
        this.$router.push(`/search?query=${query}`)
      }
    }
  }
}
